<template>
    <div class="entering-box">
        <div class="titl-box-top"> 
            {{ typeValue == '0'?'单选':'' || typeValue == '1'?'多选':''|| typeValue == '2'?'判断':'' }} 
        </div>
        <!-- 单选 -->
        <div v-if="typeValue==0">
            <el-col  v-for="(item,index) in dnaxun" style="display: inline-block;">
                <el-form-item :label="index+1+'、'"  label-width="100px" >
                    <el-radio-group v-model="item.value" :disabled="examBaseInfoObj.status==2" >
                        <el-radio label="A">A</el-radio>
                        <el-radio label="B">B</el-radio>
                        <el-radio label="C">C</el-radio>
                        <el-radio label="D">D</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-col>
        </div>
        <!-- 多选 -->
        <div v-if="typeValue==1">
            <el-col  v-for="(item,index) in duoxuan" style="display: inline-block;">
                <el-form-item :label="index+1"  label-width="100px" >
                    <el-checkbox-group v-model="item.checkList" :disabled="examBaseInfoObj.status==2">
                        <el-checkbox label="A">A</el-checkbox>
                        <el-checkbox label="B">B</el-checkbox>
                        <el-checkbox label="C">C</el-checkbox>
                        <el-checkbox label="D">D</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
            </el-col>
        </div>
        <!-- 判断 -->
        <div v-if="typeValue==2">
            <el-col  v-for="(item,index) in duicuo" style="display: inline-block;">
                <el-form-item :label="index+1"  label-width="100px" >
                    <el-radio-group v-model="item.value" :disabled="examBaseInfoObj.status==2">
                        <el-radio label="A">对</el-radio>
                        <el-radio label="B">错</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-col>
        </div>
        <div class="butto-tijiao">
            <!-- <el-button type="primary" >提交</el-button> -->
            <el-button style="margin-right: 10px;" @click="luRufanhui">返回</el-button>
            <el-button type="primary" @click="tiJiao">提交</el-button>
        </div>
    </div>
</template>

<script>
  import { examAddAnswer} from '@/assets/api/renyuan'
import { ElMessage } from 'element-plus'

export default {
    props: ['examBaseInfoObj'],
    components: {

    },
    data() {
        return {
            dnaxun: [
            //  {
            //     value:''
            //  }
            ],
            duoxuan: [
            // {
            //     checkList: [],
            // }
            ],
            duicuo: [
            //  {
            //     value:''
            //  }
            ],
            typeValue: 2,
        };
    },
    created() {
        console.log(this.examBaseInfoObj);
        this.typeValue = this.examBaseInfoObj.type
        console.log(this.typeValue, '类型');
        for (let i = 1; i <= this.examBaseInfoObj.questionCount; i++) {
            if (this.typeValue == 0) {
                this.dnaxun.push({ value: '', })
            }
            if (this.typeValue == 1) {
                this.duoxuan.push({  checkList: [], })
            }
            if (this.typeValue == 2) {
                this.duicuo.push({ value: '', })
            }
        }
        // 答题完成回显
        // this.examBaseInfoObj.status == 2 
        if ( this.examBaseInfoObj.answer != null  ) {
            console.log('回显，7777777');
            if (this.typeValue == 0) {
                let arr = this.examBaseInfoObj.answer.split(',')
                for (let index in arr) {
                    this.dnaxun[index].value = arr[index]
                }
            }
            if (this.typeValue == 1) {
                let arr = this.examBaseInfoObj.answer.split(',')
                console.log(arr[0].split(''));
                for (let index in arr) {
                    this.duoxuan[index].checkList = arr[index].split('')
                }
            }
            if (this.typeValue == 2) {
                let arr = this.examBaseInfoObj.answer.split(',')
                for (let index in arr) {
                    this.duicuo[index].value = arr[index]
                }
            }
        }
    },
    mounted() {
        
    },
    methods: {
        tiJiao () {
            if (this.typeValue == 0) { // 单选
                let danxuan = [] 
                for( let item of this.dnaxun) {
                    console.log(item,'单选****----');
                    danxuan.push(item.value)
                }
                console.log(danxuan.toString(),55555555555);
                this.examAddAnswerPost ({ answer: danxuan.toString(),examId:this.examBaseInfoObj.examId}) 
            } else if (this.typeValue == 1) { // 多选
                let duoxuan = ''                
                console.log(this.duoxuan);
                for( let index in this.duoxuan) {
                    console.log(this.duoxuan[index],'多选****----',this.duoxuan[index].checkList.join(''));
                    if ( index  == 0) {
                        duoxuan =  this.duoxuan[index].checkList.join('')
                    } else {
                        duoxuan = duoxuan +','+ this.duoxuan[index].checkList.join('')
                    }
                }
                console.log(duoxuan,5555555555555555);
                this.examAddAnswerPost ({ answer: duoxuan,examId:this.examBaseInfoObj.examId}) 
            } else if (this.typeValue == 2) { // 判断
                let strObj = []
                for( let item of this.duicuo) {
                    console.log(item,'判断****----');
                    strObj.push(item.value)
                }
                console.log(strObj.toString(),55555555555);
                this.examAddAnswerPost ({ answer: strObj.toString(),examId:this.examBaseInfoObj.examId}) 
            }
        },
        examAddAnswerPost (data) {
            examAddAnswer(data).then((res)=> {
                console.log(res);
                this.luRufanhui()
                ElMessage.success('提交成功')
            }).catch((err)=> {
                // console.log(err);
                ElMessage.error("提交失败");
            })
        },
        luRufanhui () {
            this.$emit('luruFanhui')
        },
    },
};
</script>

<style scoped lang="scss">
.entering-box {
    .titl-box-top {
        padding-left: 20px;
        font-size: 18px;
        font-weight: 600;
    }
    // width: 100%;
    .butto-tijiao {
        padding-right: 20px;
        text-align: right;
    }
    /deep/ .el-col-24 {
        width: 33.3%;
        height: 45px;
    }
}
</style>
